import type { CSSProperties } from "react"

const CELL = 48

const FADE =
	"radial-gradient(ellipse 50% 48% at 50% 50%, black 0%, transparent 100%)"

// Offset by half a cell so two grid lines cross at the input's centre.
const GRID: CSSProperties = {
	backgroundImage:
		"linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
	backgroundSize: `${CELL}px ${CELL}px`,
	backgroundPosition: `calc(50% + ${CELL / 2}px) calc(50% + ${CELL / 2}px)`,
	maskImage: FADE,
	WebkitMaskImage: FADE,
}

export const InboxAssistantBackdrop = () => (
	<div
		aria-hidden
		className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[800px] w-[1100px] -translate-x-1/2 -translate-y-1/2 text-gray-900/[0.1] dark:text-white/[0.05]"
		style={GRID}
	/>
)
